import type { ButtonHTMLAttributes, ReactNode } from 'react';
type Kind = 'primary' | 'default' | 'danger' | 'ghost';
type Size = 'sm' | 'md';
const KIND: Record<Kind, string> = {
  primary:
    'bg-primary text-white border border-primary hover:bg-primary-dark hover:border-primary-dark',
  default:
    'bg-surface text-ink border border-line hover:border-control hover:bg-bg-warm',
  danger: 'bg-danger text-white border border-danger hover:bg-danger/90',
  ghost:
    'bg-transparent text-ink-2 border border-transparent hover:bg-bg-warm hover:text-ink',
};
const SIZE: Record<Size, string> = {
  sm: 'min-h-11 px-3 py-2 text-sm-label leading-snug',
  md: 'min-h-11 px-4 py-2.5 text-body leading-snug',
};
export function Btn({
  kind = 'default',
  size = 'md',
  icon,
  children,
  className = '',
  ...rest
}: {
  kind?: Kind;
  size?: Size;
  icon?: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`inline-flex max-w-full items-center gap-2 rounded-btn text-center font-medium justify-center transition-colors duration-150 active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none disabled:active:scale-100 disabled:active:translate-y-0 ${KIND[kind]} ${SIZE[size]} ${className}`}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
